import React from 'react';
import { createRoot, hydrateRoot } from "react-dom/client";
import App from './app/App';
import './index.css';

const rootElement = document.getElementById("root");

if (rootElement.dataset.prerendered === "true") {
    hydrateRoot(rootElement, <App />);
} else {
    rootElement.innerHTML = "";
    createRoot(rootElement).render(<App />);
}
